import { all } from 'redux-saga/effects';
import loginWatcher from './login';
import signupWatcher from './signup';
import smartRouting from './smartRouting';
import settings from './settings';
import payment from './payment';
import offers from './offers';
import createCampaign from './createCampaign';
import refund from './refund';
import overview from './overview';
import analyticsWatcher from './analytics';
import merchantListingWatcher from './merchantListing';
import validationErrorsWatcher from './validationErrors';
import paymentLinksWatcher from './paymentLinks';
import adminCustomRoutingWatcher from './adminCustomRouting';
import downloadCsvWatcher from './downloadCsv';
import payoutsWatcher from './payouts';
import settlementWatcher from './settlements';
import disputeWatcher from './disputes';
import imeiWatcher from './imei';
import plansWatcher from './plans';
import subscriptionWatcher from './subsctiption';
import completeProfileWatcher from './completeProfile';
import webhookEventWatcher from './configureWebhook';
import transactionWatcher from './edgeTransactions';
import imeiValidationWatcher from './imeiValidation';
import partnerMerchantWatcher from './partnerMerchants';
import customReportWatcher from './customReport';
import wallet from './wallet';

import reportWatcher from './reports';
import onboardingWatcher from './onboarding';
import adminTransactionWatcher from './adminTransaction';
import fetchPaymentModeWatcher from './fetchPaymentModeData';
import bpclWatcher from './bpcl';
import makerCheckerWatcher from './makerChecker';
import feeConfigurationWatcher from './feeConfiguration';
import splitSettlementWatcher from './splitSettlement';
import assistedVkycWatcher from './assistedVkyc';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function* rootSaga() {
  yield all([
    loginWatcher(),
    signupWatcher(),
    smartRouting(),
    settings(),
    payment(),
    refund(),
    overview(),
    analyticsWatcher(),
    validationErrorsWatcher(),
    paymentLinksWatcher(),
    merchantListingWatcher(),
    adminCustomRoutingWatcher(),
    downloadCsvWatcher(),
    payoutsWatcher(),
    settlementWatcher(),
    disputeWatcher(),
    imeiWatcher(),
    offers(),
    createCampaign(),
    plansWatcher(),
    subscriptionWatcher(),
    completeProfileWatcher(),
    webhookEventWatcher(),
    transactionWatcher(),
    imeiValidationWatcher(),
    partnerMerchantWatcher(),
    reportWatcher(),
    onboardingWatcher(),
    adminTransactionWatcher(),
    wallet(),
    fetchPaymentModeWatcher(),
    bpclWatcher(),
    customReportWatcher(),
    makerCheckerWatcher(),
    feeConfigurationWatcher(),
    splitSettlementWatcher(),
    assistedVkycWatcher(),
  ]);
}
